(() => {
  function initialise(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    if (!form) return;
    const variantSelect = form.querySelector('[data-wm-variant]');
    const planSelect = form.querySelector('[data-wm-plan]');
    const inputs = [...form.querySelectorAll('[data-wm-flavour]')];
    const addons = [...form.querySelectorAll('[data-wm-addon]')];
    const button = form.querySelector('[data-wm-submit]');
    const message = form.querySelector('[data-wm-message]');
    const product = JSON.parse(form.querySelector('[data-wm-product]').textContent);
    const components = JSON.parse(form.querySelector('[data-wm-components]').textContent);
    const bundle = JSON.parse(form.querySelector('[data-wm-bundle]').textContent);
    const flavourNames = {dill_sour: 'Dill Sour', sweet_spicy: 'Sweet & Spicy', bread_butter: 'Bread & Butter', beer: 'Beer Pickle', kraut: 'Kraut'};
    const bundleReady = Number(bundle?.variantId) === Number(variantSelect.value) &&
      bundle?.options?.length === 6 && bundle?.components?.length === 30 &&
      inputs.every(input => {
        const component = components.find(c => c.flavour === input.dataset.flavour);
        return Array.from({length: 6}, (_, index) => `Jar ${index + 1}`).every(name =>
          bundle.components.some(entry => Number(entry.variant_id) === component?.id &&
            Number(entry.quantity_in_bundle) === 1 && entry.variant_options?.some(option =>
              option.name === name && option.value === flavourNames[input.dataset.flavour])));
      });
    inputs.forEach(input => {
      const component = components.find(c => c.flavour === input.dataset.flavour);
      input.dataset.stock = component?.available ? Math.min(6, component.limit) : 0;
    });
    const validComponents = () => inputs.every(input => Number(input.value) === 0 || Number(input.value) <= Number(input.dataset.stock));
    let busy = false;
    const storageKey = `westmont-box-v1:${variantSelect.value}`;
    function saveSelection() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({
          plan: planSelect?.value || '',
          flavours: Object.fromEntries(inputs.map(input => [input.dataset.flavour, input.value])),
          addons: Object.fromEntries(addons.map(input => [input.dataset.variant, input.value]))
        }));
      } catch {}
    }
    function restoreSelection() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey));
        if (!saved || !saved.flavours || !saved.addons) return false;
        if (planSelect && [...planSelect.options].some(option => option.value === saved.plan)) planSelect.value = saved.plan;
        inputs.forEach(input => {
          const value = Number(saved.flavours[input.dataset.flavour]);
          input.value = Number.isInteger(value) && value >= 0 && value <= size() ? value : 0;
        });
        addons.forEach(input => {
          const value = Number(saved.addons[input.dataset.variant]);
          input.value = Number.isInteger(value) && value >= 0 && value <= 99 ? value : 0;
        });
        return true;
      } catch { return false; }
    }
    const size = () => Number(variantSelect.selectedOptions[0].dataset.size);
    const total = () => inputs.reduce((sum, input) => sum + Number(input.value), 0);
    const validCounts = () => inputs.every(input => input.value.trim() !== '' && Number.isInteger(Number(input.value)) && Number(input.value) >= 0 && Number(input.value) <= size());
    function update(reset = false) {
      if (reset) {
        const mix = size() === 6 ? [2, 1, 1, 1, 1] : [1, 1, 1, 0, 0];
        inputs.forEach((input, index) => { input.value = mix[index]; input.max = size(); });
      }
      const variant = product.variants.find(v => String(v.id) === variantSelect.value);
      const planId = planSelect?.value;
      const allocation = variant?.selling_plan_allocations?.find(a => String(a.selling_plan_id) === planId);
      const validPlan = !planId || Boolean(allocation);
      const boxCents = allocation ? allocation.price : variant?.price;
      const cents = Number(boxCents || 0) + addons.reduce((sum, input) => {
        const quantity = Number(input.value) || 0;
        const extra = product.addons?.find(a => String(a.id) === input.dataset.variant);
        const extraPlan = extra?.selling_plan_allocations?.find(a => String(a.selling_plan_id) === planId);
        return sum + quantity * Number(planId && extraPlan ? extraPlan.price : input.dataset.price || 0);
      }, 0);
      form.querySelector('[data-wm-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: root.dataset.currency }).format(cents / 100);
      form.querySelector('[data-wm-counter]').textContent = `${total()} / ${size()} ${root.dataset.total}`;
      const validAddons = addons.every(input => {
        const quantity = Number(input.value);
        if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99) return false;
        if (!quantity) return true;
        const extra = product.addons?.find(a => String(a.id) === input.dataset.variant);
        return extra?.available && (!planId || extra.selling_plan_allocations.some(a => String(a.selling_plan_id) === planId));
      });
      button.disabled = busy || !variant?.available || !validCounts() || total() !== size() || !validPlan || !validAddons || !bundleReady || !validComponents();
      saveSelection();
      button.textContent = busy ? root.dataset.loading : variant?.available && validComponents() && validAddons && bundleReady ? root.dataset.addLabel : root.dataset.soldOut;
    }
    variantSelect.addEventListener('change', () => update(true));
    planSelect?.addEventListener('change', () => update());
    addons.forEach(input => input.addEventListener('input', () => update()));
    inputs.forEach(input => input.addEventListener('input', () => update()));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || button.disabled) return;
      if (!validCounts() || total() !== size()) {
        message.textContent = root.dataset.count; return;
      }
      busy = true; update(); message.textContent = root.dataset.loading;
      const selectedJars = inputs.flatMap(input =>
        Array.from({length: Number(input.value)}, () => flavourNames[input.dataset.flavour]));
      const item = {
        id: Number(variantSelect.value),
        quantity: 1,
        properties: {
          ...Object.fromEntries(selectedJars.map((name, index) => [`Jar ${index + 1}`, name])),
          _Westmont_fridge: 'six-jars'
        }
      };
      if (planSelect?.value) item.selling_plan = Number(planSelect.value);
      const items = [item, ...addons.filter(i => Number(i.value) > 0).map(i => {
        const addon = {id: Number(i.dataset.variant), quantity: Number(i.value), properties: {_Westmont_box: String(variantSelect.value)}};
        if (planSelect?.value) addon.selling_plan = Number(planSelect.value);
        return addon;
      })];
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${base}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        try { sessionStorage.removeItem(storageKey); } catch {}
        window.location.assign(`${base}cart`);
      } catch (error) {
        message.textContent = `${root.dataset.error} ${error.message}`;
        busy = false; update();
      }
    });
    window.addEventListener('pageshow', () => {
      if (!root.isConnected) return;
      busy = false;
      message.textContent = '';
      update();
    });
    update(!restoreSelection());
  }
  document.querySelectorAll('[data-wm-box]').forEach(initialise);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-wm-box]').forEach(initialise));
})();

(() => {
  function initialisePreview(root) {
    if (root.dataset.previewReady) return;
    root.dataset.previewReady = 'true';
    const size = root.querySelector('[data-wm-preview-size]');
    const counts = [...root.querySelectorAll('[data-wm-preview-count]')];
    function update() {
      const total = counts.reduce((sum, input) => sum + Number(input.value), 0);
      const valid = counts.every(input => input.value.trim() !== '' && Number.isInteger(Number(input.value)) && Number(input.value) >= 0 && Number(input.value) <= Number(size.value));
      root.querySelector('[data-wm-preview-counter]').textContent = total + ' / ' + size.value + ' ' + root.dataset.jars;
      root.querySelector('[data-wm-preview-status]').textContent = valid && total === Number(size.value) ? root.dataset.ready : root.dataset.adjust;
    }
    size.addEventListener('change', () => {
      const mix = Number(size.value) === 6 ? [2,1,1,1,1] : [1,1,1,0,0];
      counts.forEach((input, index) => { input.value = mix[index]; input.max = size.value; });
      update();
    });
    counts.forEach(input => input.addEventListener('input', update));
    update();
  }
  document.querySelectorAll('[data-wm-box-preview]').forEach(initialisePreview);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wm-box-preview]').forEach(initialisePreview));
})();




